import { createContext, useContext } from 'react';
import { type CurrentUser } from '../resources/User/types';

const CurrentUserContext = createContext<CurrentUser | undefined>(undefined);

export const CurrentUserProvider = CurrentUserContext.Provider;

export const useCurrentUser = () => {
  const user = useContext(CurrentUserContext);
  if (!user) {
    throw new Error('useCurrentUser must be used within a CurrentUserProvider');
  }

  return user;
};
